import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter} from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import theme from './themes';
import { StylesProvider, createGenerateClassName } from '@mui/styles';
import { ConfirmProvider } from 'material-ui-confirm';

const generateClassName = createGenerateClassName({
    productionPrefix: 'c',
});

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
                <ConfirmProvider>
                    <HashRouter>
                        <StylesProvider generateClassName={generateClassName}><App/></StylesProvider>;
                    </HashRouter>
                </ConfirmProvider>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
);
